import React from 'react';
import { reverse } from 'named-urls';

import { useNavigate } from 'react-router-dom';

import routes from 'core/routes';

import { isRegisterEntityModule } from 'core/constants';

import { InspectionEntity } from 'utils/api/modules/workflows/workflows.types';
import { AuditLinkEntity } from 'utils/api/modules/entities/entities.types';

import { Linked } from './styles';
import { TaskLinkedToCellProps } from './types';

const TaskLinkedToCell: React.FunctionComponent<TaskLinkedToCellProps> = ({ value: { value } }): React.ReactElement => {
  const navigate = useNavigate();

  const navigateTo = (event: React.MouseEvent): void => {
    // An audit record lives at /audits/forms/:formId, not the register `details` route.
    if (value.entity === InspectionEntity || value.entity === AuditLinkEntity) {
      const {
        instance: { uuid },
      } = value;
      navigate(reverse(routes.dashboard.audits.forms.details, { formId: uuid as string }));
    } else if (isRegisterEntityModule(value.entity)) {
      navigate(reverse(routes.dashboard[value.entity].details, { entityId: value.instance.uuid || '' }));
    }
    event.stopPropagation();
  };

  return <Linked onClick={navigateTo}>{value.instance.name}</Linked>;
};

export default TaskLinkedToCell;
